import { getCookie } from '../../../utils/helpers';

export async function trackAddToCart(data) {
  const knifeComponents = data.map((item) =>
    JSON.parse(
      item.attributes.find((attribute) => attribute.key === '_variant').value,
    ),
  );
  const eventSource = getCookie('eventSource');
  const items = [];
  knifeComponents.map((component) => {
    const componentProduct = component.product;
    items.push({
      item_name: `${componentProduct.title} - ${component.title}`,
      item_id: componentProduct.handle,
      price: parseFloat(component.priceV2.amount),
      item_brand: 'Benchmade',
      parent_internal_id: componentProduct.id.replace(
        'gid://shopify/Product/',
        '',
      ),
      parent_item_name: componentProduct.title,
      product_type: componentProduct.productType,
      item_category: 'All Products',
      item_variant: component.title,
      item_variant_internal_id: component.id.replace(
        'gid://shopify/ProductVariant/',
        '',
      ),
      handle: component.product.handle,
      availability: component.available,
      parent_item_sku:
        component.sku === null || component.sku === '' ? null : component.sku,
      quantity: 1,
    });
    return null;
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'ee.add_to_cart',
    event_source: eventSource,
    ecommerce: {
      items,
    },
  });
}

export async function trackViewCart(data) {
  const itemsToTrack = data.lines;
  const eventSource = getCookie('eventSource');
  const items = [];
  itemsToTrack.map((item) => {
    const variant = item.merchandise?.product?.variants?.edges?.find(
      (variant) => variant.node?.id === item.merchandise?.id,
    );
    items.push({
      item_name: `${item.merchandise?.product?.title} - ${variant?.node?.title}`,
      item_variant_internal_id: variant?.node?.id.replace(
        'gid://shopify/ProductVariant/',
        '',
      ),
      parent_item_sku: variant?.node?.sku,
      handle: item.merchandise?.product?.handle,
      availability: item.merchandise?.product?.available,
      item_id: item.merchandise?.product?.handle,
      price: parseFloat(variant?.node?.priceV2?.amount),
      item_brand: 'Benchmade',
      parent_internal_id: item.merchandise?.product?.id.replace(
        'gid://shopify/Product/',
        '',
      ),
      parent_item_name: item.merchandise?.product?.title,
      product_type: item.merchandise?.product?.productType,
      item_category: 'All Products',
      // eslint-disable-next-line max-len
      item_variant: variant?.node?.title,
      quantity: item.quantity,
    });
    return null;
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'ee.view_cart',
    event_source: eventSource,
    currency: window.Shopify.currency.active,
    value: parseFloat(data?.subtotal?.amount), // total value of the cart
    ecommerce: {
      items,
    },
  });
}
